import React from "react";
import { LogOut } from "lucide-react";
import { INTAKE } from "../../constants/testIds";

const EXIT_URL = "https://www.bbc.co.uk/weather";

export const performQuickExit = () => {
  // Navigate the top-level tab so we break out of any iframe (preview embeds
  // this app, and sites like BBC block being shown inside a frame).
  try {
    window.open(EXIT_URL, "_top");
  } catch (e) {
    try {
      window.top.location.href = EXIT_URL;
    } catch (e2) {
      window.location.replace(EXIT_URL);
    }
  }
};

export const QuickExit = () => {
  return (
    <button
      type="button"
      onClick={performQuickExit}
      aria-label="Quick exit — leave this site immediately"
      data-testid={INTAKE.quickExit}
      className="fixed top-4 right-4 z-50 inline-flex items-center gap-2 bg-brand-danger text-white px-4 py-2 text-sm font-semibold shadow-md hover:brightness-110 transition-[filter] duration-200"
    >
      <LogOut className="h-4 w-4" strokeWidth={2} />
      Quick exit
    </button>
  );
};
